import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, CardContent, Typography } from '@mui/material';
import React, { ReactNode, useState } from 'react';

export interface WrapperProps {
  actions?: ReactNode;
  children: ReactNode;
  header: ReactNode;
}

export const DetailsAccordion = ({ actions, children, header }: WrapperProps) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Accordion disableGutters expanded={expanded} onChange={() => setExpanded(!expanded)}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Typography component="h2" variant="h6">
          {header}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
      {actions}
    </Accordion>
  );
};

export const DetailsCard = ({ actions, children, header }: WrapperProps) => (
  <>
    <CardContent>
      <Typography component="h2" variant="h5" gutterBottom>
        {header}
      </Typography>
      {children}
    </CardContent>
    {actions}
  </>
);
